import React from 'react';
import { getApiBase } from '../apiBase';

// Lead-source channels shown on the Leads page. Each can be toggled active and
// shows its live count from the pipeline (matched by source name).
const CHANNELS = ['Instagram', 'Facebook', 'Google', 'Website', 'Referral', 'Yelp', 'Nextdoor', 'Word of mouth'];
const SOURCES_KEY = 'howto_lead_sources';

function loadSources() {
  try {
    const raw = localStorage.getItem(SOURCES_KEY);
    if (raw) return { ...Object.fromEntries(CHANNELS.map((c) => [c, true])), ...JSON.parse(raw) };
  } catch (_) {}
  return Object.fromEntries(CHANNELS.map((c) => [c, true]));
}

export default function LeadsPanel({ ownerId, onClose }) {
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState(null);
  const [sources, setSources] = React.useState(loadSources);

  const load = React.useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${getApiBase()}/api/company/leads-summary?ownerId=${encodeURIComponent(ownerId || '')}`);
      const json = await res.json();
      setData(json && json.ok ? json : { ok: true, total: 0, bySource: [] });
    } catch (_) {
      setData({ ok: false, total: 0, bySource: [] });
    }
    setLoading(false);
  }, [ownerId]);

  React.useEffect(() => { load(); }, [load]);
  React.useEffect(() => { try { localStorage.setItem(SOURCES_KEY, JSON.stringify(sources)); } catch (_) {} }, [sources]);

  const toggle = (c) => setSources((s) => ({ ...s, [c]: !s[c] }));
  const total = Math.round((data && data.total) || 0);
  const countFor = (name) => {
    const rows = (data && Array.isArray(data.bySource) ? data.bySource : []);
    const r = rows.find((x) => x && x.source && String(x.source).toLowerCase() === name.toLowerCase());
    return Math.round((r && r.count) || 0);
  };

  return (
    <div className="agent-page">
      <div className="agent-page__inner">
        <button type="button" className="agent-page__back" onClick={onClose}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
          Back
        </button>
        <div className="agent-page__title">Leads</div>
        <div className="agent-page__sub">
          {loading ? 'Loading your leads…' : `${total.toLocaleString()} lead${total === 1 ? '' : 's'} in your pipeline — by source.`}
        </div>

        <div className="agent-page__section">Lead sources</div>
        <div className="lead-sources">
          {CHANNELS.map((c) => {
            const n = countFor(c);
            return (
              <div className="lead-source" key={c}>
                <span style={{ minWidth: 0 }}>
                  <span className="lead-source__name" style={{ display: 'block', opacity: sources[c] ? 1 : 0.5 }}>{c}</span>
                  <span className="lead-source__count" style={{ display: 'block' }}>{n.toLocaleString()} lead{n === 1 ? '' : 's'}</span>
                </span>
                <label className="aswitch">
                  <input type="checkbox" checked={!!sources[c]} onChange={() => toggle(c)} />
                  <span className="aswitch__track" />
                  <span className="aswitch__knob" />
                </label>
              </div>
            );
          })}
        </div>

        <button type="button" className="sched-refresh" onClick={load} disabled={loading} style={{ marginTop: '14px' }}>Refresh</button>
        <div className="agent-detail__note">Toggle a source off to hide it. Auto-pulling new leads from a channel switches on once that platform is linked.</div>
      </div>
    </div>
  );
}
